// internationalization
import { t } from 'i18next';

// shared components
import StyledBadge from '@/components/experimental/StyledBadge';
// components/LatestJobRunCell.jsx
import HtmlTooltip from '@/components/ui/tooltip/HtmlTooltip';

const badgeContainerStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  height: '100%',
};

const statusConfig = {
  manual: {
    color: '#44b700',
    title: 'Manual Run Requested',
  },
  success: {
    color: '#44b700',
    title: 'Latest run completed',
    content: (
      <div>
        {t('subscriptionLatestRunCell.generateWeekplanSuccess', {
          ns: 'buildingOptimization',
        })}
      </div>
    ),
  },
  success_warnings: {
    color: 'orange',
    title: 'Latest run completed with warnings',
  },
  failed: {
    color: 'red',
    title: 'Latest run failed',
  },
  inactive_run: {
    color: 'grey',
    title: 'Inactive',
    content: (
      <div>
        {t('subscriptionLatestRunCell.noRecentRuns', {
          ns: 'buildingOptimization',
        })}
      </div>
    ),
  },
  inactive_no_run: {
    color: 'grey',
    title: 'Inactive',
    content: (
      <div>
        {t('subscriptionLatestRunCell.noRecentRuns', {
          ns: 'buildingOptimization',
        })}
      </div>
    ),
  },
  no_output: {
    color: 'default',
    title: 'No Output',
    content: (
      <span style={{ fontSize: '1rem' }}>
        {t('subscriptionLatestRunCell.noProcessableOutput', {
          ns: 'buildingOptimization',
        })}
      </span>
    ),
  },
};

export default function SubscriptionLatestRunCell({
  status,
  warnings = [],
  errors = [],
}) {
  const cfg = statusConfig[status] ?? statusConfig.no_output;
  const content =
    status === 'success_warnings'
      ? warnings?.map((w, i) => <div key={i}>{w?.message}</div>)
      : status === 'failed'
        ? errors?.map((e, i) => <div key={i}>{e?.message}</div>)
        : cfg.content;

  return (
    <div style={badgeContainerStyle}>
      <HtmlTooltip title={cfg.title} content={content} placement="right">
        <StyledBadge color={cfg.color} enableRipple={false} />
      </HtmlTooltip>
    </div>
  );
}
